<script>
import i18n from "../i18n";
import { menuItems } from "./horizontal-menu";
import { anonymousMenuItems } from "./anonymous-Menu-Items";
import PartnerApi from "@/services/partner-api";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}
 

/**
 * Nav-bar Component
 */
export default {
  computed: {
    permission() {
         const  storedPermissions = JSON.parse(getCookie('permission')) || [];
        return storedPermissions
        },

    notifPagesNbr() {
      return Math.ceil(this.notificationsCount / this.notifPageSize);
    },

    userShortName() {
      var short = this.$cookies.get('userFullName') /* this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName').split(' ')[0] : ''*/;      
      return short.length > 7 ? short.substring(0, 7) + '...' : short;
    },

    userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    },

    companyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName').length > 10 ? this.$cookies.get('companyName').substring(0, 10) + '...' : this.$cookies.get('companyName') : '';   
    },

    fullCompanyName() {
      return this.$cookies.isKey('companyName') ? this.$cookies.get('companyName') : '';   
    },

    isSupplier() {
      return this.$cookies.get('userr') == 1;
    },

    isAdmin() {
      return this.$cookies.get('userr') == 2;
    },

    role() {
      return this.$cookies.get('userr');
    },

    draftOrderId() {
      return this.$cookies.isKey('drafto') ? this.$cookies.get('drafto') : null;
    },

    draftOrderLinesCount() {
      return this.$cookies.isKey('draftoc') ? this.$cookies.get('draftoc') : null;
    },
    
    

  },
  data() {
    return {
      languages: [
        {
          language: "fr",
          title: "French",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      keyword:"",
      supplierFullName:'',

      interval: null,

      notifications: [],
      notificationsCount: 0,
      notifPage: 1,
      notifPageSize: 3,

      selectedUserList:[],
      showUsersModal:false,

      showDraftOrder: false,

      menuItems: menuItems,
      anonymousMenuItems: anonymousMenuItems,
      countLastRequestQuote: null


    };
  },

  created() {
      if(this.isSupplier){
        this.getCountLastRequestQuote()
        this.interval = setInterval(this.getCountLastRequestQuote, 60000)
      }
    },
    beforeDestroy () {
      clearInterval(this.interval);
    },

  mounted() {
    

    this.$root.$on('order-changed-event', () => {
        this.$cookies.refresh()
    })

    this.$root.$on('order-submitted', () => {
        this.$cookies.refresh()
    })

    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

  },
  methods: {
    getCountLastRequestQuote() {

      PartnerApi.getCountLastRequestQuote()
      .then(result => {
        if (result) {
          this.countLastRequestQuote = result;
        }
      })
      },

    
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.lan = locale;
      this.text = country;
      i18n.locale = locale;
    },

    toNotificationIcon(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "fas fa-dolly";
        case 1: return "fas fa-check-double";
        case 2: return "fas fa-truck-loading";
        case 3: return "fas fa-exclamation-triangle";
        case 4 : return "fas fa-file-invoice-dollar";
        default : return "fas fa-dolly";
      }
    },

    toNotificationColor(notificationType) {
      if (notificationType == null) {
        return;
      }
      switch (notificationType) {
        case 0: return "bg-danger";
        case 1: return "bg-info";
        case 2: return "bg-success";
        case 3: return "bg-secondary";
        case 4: return "bg-primary";
        default : return "bg-secondary";
      }
    },

    toPath(notificationType){
      if (notificationType == null) {
        return;
      }
      if(notificationType==0 || notificationType==1 || notificationType==2 || notificationType==3){
        return '/orders/order'
      }
    },

    toQuery(notif){
      if (notif == null) {
        return;
      }
      if(notif.type==0 || notif.type==1 || notif.type==2 || notif.type==3){
        return notif.orderId
      }

      if(notif.type==4){
        return null
      }
    },

    connect() {
      if(!this.userFullName) {
        this.$router.push({ name: "login" });
      }
    },

    onDraftModalClose() {
      this.$root.$emit('order-cart-modal-closed', true)
    },

    

  },

  watch :{

    '$route.query.filter': {
        handler: function(filter) {
          this.keyword = filter;
        },
        deep: true,
        immediate: true
    },

    role: function() {
  
    },


    

    
  }

  


};
</script>

<style>
  /* .navbar-header .dropdown.show .header-item {
    background-color: #5cb45b;
} */

    .navbar-header .mobile-user-button .dropdown .dropdown-menu {
        left: 10px !important;
        right: 10px !important;
        min-width:300px;
    }

    @media all and (max-width: 1024px) and (min-width: 1024px) {
    #logo {
        padding-left: 20px;
    } 

    }


  
    .menu {
      overflow-x: scroll;
      overflow-y: hidden; 
      white-space: nowrap;
      width: 100%;
      height: 100%; 
      -ms-overflow-style: none; 
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }

    .menu::-webkit-scrollbar {
      display: none; /* hide scrollbar on Chrome and Safari */
    }

    .menu:active {
      cursor: grab;
      cursor: -webkit-grab;
    }

    .menu:active::-webkit-scrollbar-thumb {
      background-color: #ddd;
    }

    .menu:active::-webkit-scrollbar-track {
      background-color: #f1f1f1;
    }

    .menu ul {
      display: flex; /* use flexbox to make menu items expand to fill available space */
      align-items: stretch; /* stretch menu items to the full height of the menu */
    }

    .menu li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /*border-bottom: 3px solid white;*/
  /*border-top: 3px solid white;*/
  cursor: pointer;
  position: relative;
}

/* .menu li a:hover {
  color: #00acc8 !important;
} */

.menu li.active a,

.menu li.active,
.menu li:hover {
  /*border-bottom: 3px solid #137437;*/
  color: #137437 !important;
}

.menu_title {
  color: white !important;
  text-shadow: 
    2px 2px 4px rgba(29, 185, 100, 0.5), 
    -2px -2px 6px rgba(0, 255, 255, 0.8);
}


.menu_title:hover {
  /*background-color: #ddd;*/
  color: #cfcece !important;
}


.menu li a {
  display: flex; /* enable flexbox layout */
  align-items: center; /* center link content vertically */
  justify-content: center; /* center link content horizontally */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-decoration: none;

  color: #333;
  text-decoration: none;
      font-size: 14px;
      font-weight: bold;
}

menu ul {
      display: inline-block;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

  

</style>

<template>  
<div :class="$route.name != 'default'  ? 'navbar-header' : '' "  >
 
  <!-- style="border-bottom: 1px solid #f4f4f4;" #61b083ab  #d1e5d57a -->
  <header id="page-topbar" :style=" $route.name != 'default'  ? '':    '  background: linear-gradient(to bottom,  transparent, #ddd, transparent);'"  >
  <!-- <header id="page-topbar"  > -->


    <!-- LOGO BLOCK & MOBILE MENU BUTTON -->
    <div class="navbar-header"   >


      <div class="row w-100 m-sm-4 m-0 " >

        <div class="col-1 col-md-6 col-lg-2 col-xl-2 col-xxl-3" style="z-index:9999999">
            <div class="d-flex mobile-user-button">

              <b-dropdown  v-if="!userFullName" right variant="black" toggle-class="header-item noti-icon" class="  d-block d-lg-none "  >
                    <template v-slot:button-content>
                      <img class="my-auto" src="@/assets/icons/menu.svg" alt height="45" />
                    </template>
      
                    <div class="menu-mobile">
                      
                      <ul style="margin: 0; height: 100%;">
                        <template v-for="(item, index) in anonymousMenuItems">
                          <li
                            :class="$route.name !== 'default' && $route.path === item.link ? 'active' : ''" 
                            :key="index"
                            role="menuitem"
                          >
                            <router-link
                              class="text-dark text-uppercase d-block w-100"
                              :to="item.link"
                              role="button"
                              @click="onMenuClick($event)"
                            >
                              {{ $t(item.label) }}
                            </router-link>
                          </li>
                        </template>
                      </ul>
                    </div>

                  <b-dropdown-divider v-if="userFullName && isSupplier"></b-dropdown-divider>

               </b-dropdown>

              <!-- MAIN LOGO -->
              <div class="my-auto" >
                <router-link to="/" class="logo logo-light  " id="logo" >
                  <span class="logo-sm">
                    <img class="ml-2" src="@/assets/images/logo-mini.png"   alt height="15"  />
                  </span>
                  <span class="logo-lg">
                    <img src="@/assets/images/logo.png" alt height="30" />
                  </span>
                </router-link>
              </div>
            </div>
            
        </div>

        <div class="col-0 col-md-0 col-lg-8 col-xl-8 col-xxl-6 d-none d-lg-block my-auto" style="margin-top: 0px !important;margin-bottom: 0px !important;">

              <div class="my-auto" style="height:100%;" >
                  
              
                <div class="menu">
                <ul  v-if="userFullName" style="height:100%;"> 
                    <template v-for="(item, index) of menuItems" > 
                        <li :class="$route.name != 'default' && $route.path == item.link ?  'active' : ''" :key="index"  v-if=" role == null ? item.role==0  : 
                        (item.role==role && !item.onlyPartner && ( permission && permission.some(pr=> item.subRole!=null ? item.subRole.includes(pr) :true )  || item.subRole==null )  )  " >
                            <!-- :class="userFullName || $route.name != 'default' ? 'text-dark' :'menu_title' "  class=" mr-4 ml-4" -->
                          <router-link
                            class="text-dark mr-4 ml-4" 
                            :to="item.link"
                            role="button"
                            @click="onMenuClick($event)" 
                            >
                            {{ $t(item.label) }}
                            <span 
                                v-if="item.link == '/demande/devis' && countLastRequestQuote" 
                                class="badge text-white d-flex align-items-center justify-content-center ml-1 mb-2"
                                :class="[
                                  countLastRequestQuote == 0 ? 'd-none' : '',
                                  'circular-badge font-weight-bold font-size-12 bg-danger'
                                ]"
                              >
                                {{ countLastRequestQuote > 99 ? '+99' : countLastRequestQuote }}
                              </span>

                          </router-link>
                        </li>
                    </template>
                  </ul>
                  
                  <ul v-else style="margin: 0; height: 100%;">
                    <template v-for="(item, index) in anonymousMenuItems">
                      <li
                        :class="$route.name !== 'default' && $route.path === item.link ? 'active' : ''" 
                       
                        :key="index"
                      >

                      <!-- role="menuitem"
                          aria-current="$route.path === item.link ? 'page' : null" -->
                        <router-link
                          class="text-dark text-uppercase"
                          :to="item.link"
                          role="button"
                          @click="onMenuClick($event)"
                        >
                         {{ $t(item.label) }}
                        </router-link>
                      </li>
                    </template>

                  </ul>


                </div>




                

              </div>

        </div>

        <div class="col-11 col-md-6 col-lg-2 col-xl-2 col-xxl-3 text-right">
              <!-- NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON -->
              <div class="">

                  
                  <!-- LEFT USER BUTTON -->
                  <!-- style="border-bottom:4px solid #00acc8; border-radius:0px;" -->
                  <b-dropdown right variant="black" toggle-class="header-item noti-icon" class=" d-md-inline-block  "  >
                    <template v-slot:button-content>


                      <!-- <div class="row d-none d-sm-flex" @click=" connect()"  > -->
                        <!-- border: 2px solid #00acc8 -->
                        <!-- d-none d-sm-flex -->
                      <div class="row p-1" >

                          <div class="col-xl-12 col-lg-12 pt-2 text-left" >
                            <span class=" p-2" :class="userFullName && userShortName ? 'text-primary' : 'text-primary'" :title="userFullName" style="font-size:16px;font-weight:bold;"> 
                              <img   alt=""  width="17px" fill="#137437" class="mb-2 mr-1"  src="@/assets/icons/user.svg"  />

                              <span class="">{{userFullName && userShortName ? userShortName : 'Client'}}</span></span>
                          </div>

                      </div>

                                
                    </template>

                        <a v-if="!userFullName" href="/login" class="dropdown-item w-100 p-md-2 p-2" >
                              <h5 class="text-primary font-weight-bold"> <img   alt=""  width="17px" class="mr-1"  src="@/assets/icons/user-p.svg"  />Espace client</h5>
                              <span class="text-primary ">
                                Si vous avez déjà un compte ?
                              </span>
                        </a>

                        <a v-if="!userFullName" href="/devis" class="dropdown-item mt-4 p-md-2 p-2" >
                              <h5 class="text-dark font-weight-bold"> Devenez client !</h5>
                              <span class="text-secondary ">
                                Obtenez votre <strong>devis gratuit</strong> en quelques clics  
                              </span>
                        </a>
          
                        <a v-if="userFullName" href="/" class="dropdown-item text-dark" >
                          <img  alt="home"  width="20px" class="mr-2"  src="@/assets/icons/home.svg" style="cursor: pointer;"  />
                              {{ $t('dropDown.home.text') }}                     
                        </a>


                        
<!--                         <b-dropdown-divider v-if="userFullName && (role== 1 || permission.includes('CUSTOMER_ADMIN')|| permission.includes('ORDER_LIST'))"></b-dropdown-divider>



                        <a v-if="userFullName && (isSupplier || permission.includes('CUSTOMER_ADMIN')|| permission.includes('REPORTING'))" href="/reporting" class="dropdown-item text-dark" >
                              <img  alt="analytics-graph"  width="20px" class="mr-2"  src="@/assets/icons/analytics-graph.svg" style="cursor: pointer;"  />
                              {{ $t('dropDown.Reporting.text') }}                       
                        </a> -->


                        <b-dropdown-divider v-if="userFullName && isSupplier"></b-dropdown-divider>



                        <a v-if="userFullName && isSupplier" href="/zone" class="dropdown-item text-dark" >
                          <img  alt="map"  width="20px" class="mr-2" fill="#fff" src="@/assets/icons/map.svg" style="cursor: pointer;"/>
                          {{ $t('dropDown.partner.text') }} 
                        </a>

                        <a v-if="userFullName && isSupplier " href="/utilisateurs" class="dropdown-item text-dark" >
                        <img  alt="users"  width="20px" class="mr-2"  src="@/assets/icons/users.svg" style="cursor: pointer;"  />
                              {{ $t('dropDown.users.text') }} 
                        </a>
                        <a v-if="userFullName && isSupplier " href="/campaign" class="dropdown-item text-dark" >
                        <img  alt="campaign"  width="20px" class="mr-2"  src="@/assets/icons/campaign.svg" style="cursor: pointer;"  />
                              {{ $t('dropDown.campaign.text') }} 
                        </a>

                        <a v-if="userFullName && isSupplier" href="/demande/devis" class="dropdown-item text-dark" >
                              <img  alt="adversal"  width="20px" class="mr-2"  src="@/assets/icons/status.svg" style="cursor: pointer;"  />

                              Demandes Devis
                        </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName && isSupplier" href="/bannieres" class="dropdown-item text-dark" >
                              <img  alt="adversal"  width="20px" class="mr-2"  src="@/assets/icons/settings.svg" style="cursor: pointer;"  />

                              {{ $t('dropDown.Configuration.text') }} 
                        </a>


                        <a v-if="userFullName" :href="isSupplier ?  '/reporting' : '/analytics' " class="dropdown-item text-dark" >
                            <img  alt="analytics"  width="20px" class="mr-2"  src="@/assets/icons/analytics.svg" style="cursor: pointer;"  />

                            <!-- <img   alt=""  width="17px" fill="#137437" class="mb-2 mr-1"  src="@/assets/icons/report.svg"  /> -->

                            {{ $t('dropDown.Analytics.text') }}
                      </a>

                        <a v-if="userFullName" href="/profil" class="dropdown-item text-dark" >
                          <img  alt="user"  width="20px" class="mr-2"  src="@/assets/icons/user-alt.svg" style="cursor: pointer;"  />
                            {{ $t('dropDown.profil.text') }} {{this.userFullName}}
                      </a>

                        <b-dropdown-divider v-if="userFullName"></b-dropdown-divider>

                        <a v-if="userFullName" href="/logout" class="dropdown-item text-danger font-weight-bold" >
                          <img  alt="sign-out"  width="20px" class="mr-2"  src="@/assets/icons/sign-out.svg" style="cursor: pointer;"  />
                            {{ $t('dropDown.logOut.text') }}
                        </a>

                  </b-dropdown>
                  <!-- END USER BUTTON -->

              </div>
              <!-- END NOTIFICATIONS BUTTON + CART + LEFT USER BUTTON  -->
        </div>


      </div>

    </div>

  </header>

</div>

</template>


<style scoped>
.menu-mobile {
  width: 100%;
  background-color: #fff; 
  position: fixed;
  top: 0;
  z-index: 1000; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    flex-direction: column; 
    justify-content: space-between;
    height: 100%;

    li {
      padding: 15px 20px;
      text-align: left;
      font-size: 1rem;
      transition: background-color 0.3s ease, color 0.3s ease;

      &.active {
        background-color: #f0f0f0;
        font-weight: bold;
        border-left: 4px solid #137437;
      }

      &:hover {
        background-color: #e9ecef;
      }

      .text-dark {
        color: #333;
        text-decoration: none;
      }

      .text-uppercase {
        text-transform: uppercase; 
      }
    }
  }

  a {
    color: inherit; 
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: 768px) {
    ul {
      flex-direction: row; 
    }

    li {
      padding: 10px 15px; 
    }
  }
}

.circular-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}


</style>